import api from "./api";

export const postChangePasswordForgot = async (body) => {
  return api
    .post({
      body,
      endpoint: "/auth/forgot/change-password",
      port: process.env.REACT_APP_PORT_OWNER,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
